import { render, staticRenderFns } from "./sr1.vue?vue&type=template&id=4d0b081e&scoped=true&"
import script from "./sr1.vue?vue&type=script&lang=js&"
export * from "./sr1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0b081e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdGG/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d0b081e')) {
      api.createRecord('4d0b081e', component.options)
    } else {
      api.reload('4d0b081e', component.options)
    }
    module.hot.accept("./sr1.vue?vue&type=template&id=4d0b081e&scoped=true&", function () {
      api.rerender('4d0b081e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/systemReport/sr1.vue"
export default component.exports